// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'
import _map from 'lodash/map'

// Selectors
import { crops$ } from 'fc-model-crops'
import { operation$ } from 'hfty-recommendations'

// Constants
import {
  RECOMMENDATION_TYPES,
  AG_PHD_MAINTENANCE,
  AG_PHD_BUILD_BALANCE,
  BOTH,
  UNSUPPORTED,
  PROP_CROP,
} from 'hfty-model-recommendations/src/constants'

// Utils
import traverse from 'fc-utils/traverse'

// Constants
import { PROP_HEFTY_REC_SUPPORT, PROP_NAME } from 'fc-model-crops/src/constants'

export default createSelector(
  [operation$, crops$],
  (operation, crops) => {
    if (operation) {
      const cropSelected = traverse(['model', PROP_CROP])(operation)
      const crop = _find(crops, { id: cropSelected })
      const supportedRecType = traverse([PROP_HEFTY_REC_SUPPORT])(crop)

      if (supportedRecType === BOTH) {
        return _map(RECOMMENDATION_TYPES,
          (recommendation) => ({value: recommendation.value, label: recommendation.label}))
      } else if (supportedRecType === AG_PHD_BUILD_BALANCE.value) {
        return [AG_PHD_BUILD_BALANCE]
      } else if (supportedRecType === AG_PHD_MAINTENANCE.value) {
        return [AG_PHD_MAINTENANCE]
      } else if (supportedRecType === UNSUPPORTED) {
        return [{
          label: `Sorry, ${crop[PROP_NAME]} doesn't support a recommendation type.`,
          value: null,
        }]
      }
    }
    return []
  }
)
